import { Opportunity } from "@/opportunity/opportunity";
import ConditionalStaffOnly from "@/opportunity/opportunity_detail_page/ConditionalStaffOnly";
import React from "react";
import { CircleAlert } from "lucide-react";

export const DefaultValueWarning = (
  {
    opportunity,
    opportunityKey,
    openEditDialog,
    showStaffView = true, // Default to true for backward compatibility
  }: {
    opportunity: Opportunity,
    opportunityKey: keyof Opportunity,
    openEditDialog: () => void,
    showStaffView?: boolean;
  }
) => {
  if (opportunity[opportunityKey]) {
    return;
  }

  return (
    <ConditionalStaffOnly showStaffView={showStaffView}>
      <div className="flex flex-row items-center gap-2 text-gray-400">
        <CircleAlert size={14}/>
        <div>
          This field is using the category's default value for <span className="italic">{opportunityKey}</span>.
          To set a custom value for this opportunity,
          {' '}
          <a
            className="underline cursor-pointer"
            onClick={openEditDialog}
          >
            click here
          </a>.
          To update the default value for this field,
          {' '}
          <a
            className="underline"
            target="_blank"
            href={`${import.meta.env.VITE_API_URL.replace(/\/api\/$/, "")}/admin/opportunities/opportunitycategory/${opportunity.category_object.id}/change/`}
          >
            edit the category in ThaloOS.
          </a>
        </div>
      </div>
    </ConditionalStaffOnly>
  )
}

